
export default function validateOneLiner(oneLiner) {
  const minLength = 10; 
  const maxLength = 140;

  if (!oneLiner || oneLiner.trim().length < minLength) {
    return { valid: false, reason: "too short" };
  }

  if (oneLiner.length > maxLength) {
    return { valid: false, reason: "too long" };
  }

  return { valid: true };
}
